import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {UiLoadingModel} from '../loading/models/UiLoadingModel';
import * as filesaver from 'file-saver';
import {MsgTypeDownloadEnum} from './enum/msgTypeDownload.enum';

@Component({
    selector: 'app-file-download',
    templateUrl: './file-download.component.html',
    styleUrls: ['./file-download.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileDownloadComponent implements OnChanges {

    @Output() userWantsDownloadEvent = new EventEmitter<boolean>();
    @Input() backendResponse: any;

    MSG_TYPE_ENUM = MsgTypeDownloadEnum;

    loadingModel: UiLoadingModel;
    msgType: MsgTypeDownloadEnum;

    filename: string;

    constructor() {
        this.msgType = null;
        this.filename = 'file';
        this.setDefaultLoading();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.backendResponse?.currentValue) {
            this.onFileReceivedHandler(this.backendResponse);
        }
    }

    setDefaultLoading(): void {
        this.loadingModel = new UiLoadingModel();
    }

    onFileReceivedHandler(backendResponse: any): void {
        const status: string = backendResponse?.status.toString();
        // is ok status like : 200, 201....
        if (status.startsWith('2')) {
            const filename = backendResponse.headers.get('content-disposition').split('=');
            const blob = new Blob([backendResponse.body], {
                type: backendResponse.headers.get('content-type'),
            });
            filesaver.saveAs(blob, filename[1].slice(1, -1));
            this.msgType = MsgTypeDownloadEnum.SUCCESS;
        } else {
            this.msgType = MsgTypeDownloadEnum.ERROR;
        }
        this.loadingModel.isLoading = false;
    }

    /* EVENTS */
    onClickBtn(): void {
        this.userWantsDownloadEvent.next(true);
        this.loadingModel.isLoading = true;
    }
}
